import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {formatDate} from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { ClassificationCModel } from 'src/app/models/ClassificationCModel';
import { ClassificationCService } from 'src/app/services/ClassificationCService';
import swal from 'sweetalert2';
import { ContClassSearchComponent } from '../cont-class-search/cont-class-search.component';

@Component({
  selector: 'app-cont-class',
  templateUrl: './cont-class.component.html',
  styleUrls: ['./cont-class.component.css']
})
export class ContClassComponent implements OnInit {
  clasCCode ='' ;
  clasCName ='' ;
  clasCNotes ='' ;
  userID ='sa' ;
  compCode ='1' ;
  modifaiedDate = '2021-01-01';
  constructor(
              public contclassservice : ClassificationCService,
              public contclass : ClassificationCModel,
              public translate: TranslateService,
              public storage: LocalStorageService,
              private dialogref: MatDialog,
              public contclassSelectedData : ClassificationCModel,
  ) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }


  retriveClass(){
    this.contclassservice.getClassificationC(this.clasCCode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: ClassificationCModel) => {

        //this.clasCCode = data.clasCCode;
        this.clasCName = data.clasCName;
        this.clasCNotes = data.clasCNotes;

        this.userID = data.userID;
        this.modifaiedDate = data.modifaiedDate;
        this.compCode = data.compCode;

      }
    );
  }
  submitClass(){
    if (this.clasCCode == '' || this.clasCCode == null) {
      return;
    }

    this.contclass.clasCCode = this.clasCCode;
    this.contclass.clasCName = this.clasCName;
    this.contclass.clasCNotes = this.clasCNotes;

    this.contclass.userID = this.storage.retrieve('stguserId');
    this.contclass.modifaiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.contclass.compCode = this.storage.retrieve('stgcompcode');
    this.contclassservice.AddClassificationC(this.contclass).subscribe(data => {
    this.mesgSave();
    },
      error => { alert(error); }
    );
  }
  DeleteClass(){
    this.contclassservice.DeleteClassificationC(this.clasCCode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: ClassificationCModel) => {
      }
    );
    this.NewData();
  }
  MesgDelete(){
    swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.DeleteClass();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  NewData(){
    this.clasCCode = '';
    this.clasCName='';
    this.clasCNotes='';
  }
  mesgSave() {
    swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }
  openDialog(){
    const dialogRef = this.dialogref.open(ContClassSearchComponent,
      {
        data: {
          dataKey: this.contclassSelectedData
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.clasCCode = result.clasCCode;
        this.clasCName = result.clasCName;
        this.clasCNotes = result.clasCNotes;

        this.compCode = result.compCode;
        this.userID = result.userID;
        this.modifaiedDate = result.modifiedDate;
        this.retriveClass();
        dialogSubmitSubscription.unsubscribe();
      });
  }
}
